export default function params(data: Object) {
  return Object.keys(data)
    .filter((key) => !!data[key])
    .map((key) => `${key}=${data[key]}`)
    .join('&');
}
